export const HOME_EQUIPMENTS_CONTENT = {
    intros: [
        '健豪印刷成立在 1997 年 12 月。創立初期只有分色、大圖及網片輸出的服務；在張總經理訓嘉先生的領導下，慢慢增加營業項目，並開發出網路資訊系統傳檔及下單，讓全世界客戶皆可從網路下單發印，再透過預先安排的生產流程，集單、生產、理貨、物流等一貫化作業流程，大大顛覆傳統印刷業的營運方式，且時至今日，健豪全台已有 100 餘部的專車，分北、中、南三區配送，努力達到 12 小時配送至全台各地的交件目標。',
        '為提供顧客充足的上傳頻寬、節省等待上傳的時間，並可在短時間內快速上傳檔案，健豪共建置兩條 1G 及三條 100M 雙向 FTTB 光纖網路；在健豪伺服器的記錄中，曾於一個小時內接收近兩仟個總大小近 25G 的檔案！每日客戶可上傳數萬個檔案。為讓客戶可查詢半年內的發印資料，特地購置 1000T 的空間來儲存一般印件資料；相片書資料的部份，更採購了最大可達 4P（4000T）的儲存設備來存放相片書資料。所以健豪平均每年耗資數千萬元在資訊設備上，並開發印刷業獨有的「電子商務系統」及「線上編輯器」，其簡單操作的方式，消費者只要會上網，就能在雲端上製作屬於自己的個人化商品，簡單到就算是小學生也會使用。健豪強大的IT資訊能力，搭配注入數億元的自動化生產設備、創新的資訊化流程、每天處理超過上萬筆的訂單量，這樣創新經營的方式，以「數位雲端：電子商務模式」再創產業新奇蹟！',
        '健豪的創新經營，在 2012 年與宏達電、台積電等大廠一起榮獲台灣經濟部工業局百強創新企業的殊榮、獲得 G7 企業認證，2013 年更榮獲中國創新印刷企業前十強，另取得台灣、香港及中國新型發明機械的專利。2015 年更史無前例榮獲經濟部第四屆國家產業創新獎 - 服務創新類績優創新企業獎！在一連串的突破創新、獲得各大獎項的肯定，健豪已成為兩岸三地最大的雲印刷生產基地，更將「印刷服務」商品化，推出商品說明型錄、首創門店展間規劃、突破傳統打造全新印刷商品體驗區，展示健豪所有印刷應用品項，讓消費者充分感受，印刷生活化的時代已經來臨了！',
        '2015 年的健豪已經完成南部基地增加印刷設備及產能的規劃、2016 年的健豪，已分別在進行北部及中部的廠房擴建、增加產能設備、拓展門店的計畫；在軟體上將提供更多行動裝置的使用功能、讓商品品項無限延伸，隨時隨地輕鬆發印或製作個人專屬商品。健豪也努力邁向國際化，多項海外投資合作案同步進行，將有效延伸台灣的成功經驗，以穩健的步伐，放眼海外市場與世界接軌，迎向嶄新的印刷新時代！',
        '健豪將持續秉持著「取之於社會、用之於社會」的信念，每年固定捐贈社福團體、政府機關、學術單位，以培養後進、盡一份企業責任；在照顧員工部分，也把盈餘九成分給一起打拼的員工；在服務客戶部分，健豪會持續不斷的追求進步，因為客戶不吝對健豪提出各種建議，讓健豪能夠精益求精，也因為客戶對健豪的信任與期許，才能一步一腳印的達到所追求的指標：速度、品質、服務！唯有達到這些指標，才能讓客戶滿意，因為客戶的滿意，就是健豪的最終使命！',
    ],
    history: [
        {
            year: 107,
            content: [
                '二月：健豪年度尾牙，於大台中會展中心舉辦，宴請全體同仁、熱鬧非凡！',
                '三月：精科廠新機發表會與客戶共襄盛舉。',
                '四月：新莊廠舉辦新機發表會，提供更多元的服務。',
                '五月：於6/5上午於台中工業區內，舉行健豪雲端事業總部新建工程動土典禮，健豪印刷董事長葉翠蘭與總經理張訓嘉以及台中市市長林佳龍等貴賓一起出席舉行動土儀式，新廠辦預期在2019年底正式營運。',
            ],
        },
        {
            year: 106,
            content: [
                '一月：健豪年度尾牙，於大台中會展中心舉辦，宴請全體同仁、熱鬧非凡！',
                '三月：高雄廠新機發表會，提供更快速服務。',
                '七月：首次舉辦「小小自造者夏令營」，同仁們帶領小學童，一起動手製作專屬商品，讓近百位小學童度過難忘及充實快樂的暑假。',
                '九月：健豪20週年慶嘉年華，現場有新品發表及各種精彩活動！',
            ],
        },
        {
            year: 105,
            content: [
                '一月：健豪年度尾牙，於台中林酒店及高雄翰品酒店舉辦，宴請全體同仁、熱鬧非凡！',
                '五月：健豪雲端數位學園首次開課。',
                '九月：新竹營業處正式開幕，座落於新竹縣竹北市，為健豪全省第九個營業據點。',
                '九月：健豪攝影學院首次開課。',
            ],
        },
        {
            year: 104,
            content: [
                '三月：健豪舉辦新機新品發表會，超過萬名客戶共襄盛舉。',
                '六月：健豪榮獲第四屆國家產業創新獎。',
            ],
        },
        {
            year: 103,
            content: [
                '一月：健豪年度尾牙，於台中烏日大台中國際會展中心舉辦，宴請全體同仁、熱鬧非凡！',
                '四月：於健豪精科廠，舉辦HP Scitex FB10000大圖新機 新品發表會。',
                '七月：於精科廠舉辦第五屆健豪盃桌月曆比賽頒獎典禮。',
                '九月：於健豪精科廠安裝，安裝scodix 數位局部上光機。',
                '九月：健豪印刷榮獲第八屆金印獎，優選肯定！',
                '九月：於健豪精科廠，安裝數位棉T直噴機。',
                '十月：健豪首次參加TIGAX印刷展，現場有新品發表及各種精彩活動，熱鬧非凡！',
            ],
        },
        {
            year: 102,
            content: [
                '一月：三重工廠5K5色+UV上光印刷機已安裝成功。',
                '二月：健豪年度尾牙，於台中烏日高鐵站旁舉辦，席開273桌宴！',
                '二月：於健豪精科廠，安裝馬天尼數位騎馬釘機及穿線機。',
                '三月：健豪精科新廠落成啟用！',
                '四月：於健豪精科廠，安裝HP10000 數位印刷機。',
                '五月：HP Designjet L26500大型繪圖機安裝於台中總公司，輸出品質聘美印刷品。',
                '六月：於健豪精科廠，安裝中4K及中9K信封機。',
                '七月：於精科廠舉辦第四屆健豪盃桌月曆比賽頒獎典禮。',
                '八月：Hp Latex 3000大型繪圖機安裝於台中精科廠，輸出寬幅全國最大(320cm)，品質精美。',
                '十月：健豪印刷榮獲 中國創新印刷企業前十強 ，是唯一獲獎台灣廠商！',
            ],
        },
        {
            year: 101,
            content: [
                '元月：健豪100年度尾牙，於台中新廠舉辦，宴請全體同仁、熱鬧非凡！',
                '一月：健豪新廠，安裝馬天尼數位精裝機(精裝線)及馬天尼膠裝機(膠裝線)。',
                '二月：健豪新廠，安裝可自動機上校色的XL-105印刷機。',
                '三月：健豪新廠，安裝全台唯一5K6色+UV上光印刷機。',
                '四月：中和廠重新裝潢，業界唯一印刷旗艦店，提供舒適的發稿、諮詢空間。',
                '六月：全台灣第一台HP數位印刷機裝機，每小時A4產能達28000頁（4年一度的德國印刷展 剛展出，健豪就剛裝機）。',
                '七月：於健豪精科新廠安裝HP UV繪圖機裝機，提供各式板材直噴，完美結合素材， 品質更好。',
                '八月：局部雷射上光機裝機完成。',
                '九月：線上相片書(online版)正式上線！',
                '十二月：於中和廠安裝HP UV繪圖機裝機，提供各式板材直噴，完美結合素材，品質更好。',
                '十二月：於健豪精科新廠，舉辦HP數位印刷專業評賞會。',
                '十二月：於健豪精科廠，安裝馬天尼數位膠裝機(膠裝線)。',
            ],
        },
        {
            year: 100,
            content: [
                '年初：擴充光纖專線；分公司以200M專線互連，對外共200M的頻寬以接收客戶檔案。對內各分公司以200M專線互連，提升客戶檔案處理速度！',
                '元月：月中，健豪99 年度尾牙，假健豪台中工廠舉辦，宴請全體同仁、熱鬧非凡！',
                '二月：台中工廠舉辦春酒暨印刷產品發表會，廣邀中部及南部客戶參加，並提供多種獎品抽獎 ',
                '二月：三重工廠舉辦春酒暨印刷產品發表會，廣邀北部客戶參加，並提供多種獎品抽獎。 ',
                '二月：高雄工廠新廠位於民族一路，落成啟用。 ',
                '二月：台中工廠安裝全自動書殼封面機，提升生產效率。 ',
                '五月：台中工廠安裝PUR 膠裝機。',
                '五月：全台第一台原廠原裝菊全H-UV印刷機，於三重工廠安裝成功，正式量產！',
                '六月：三重工廠安裝，全自動高速水性覆膜機 裝機成功 ',
                '七月：台中工廠安裝Kodak NexPress Sx3900 數位印刷機。',
            ],
        },
        {
            year: 99,
            content: [
                '一月：新增局部上光機102X71公分。社子店新增大圖機器設備，提供更快速服務。',
                '二月：台中工廠新安裝小森四六全四色印刷機，全開尺寸、印刷效率更快速！',
                '三月：台中工廠新安裝歐式信封機、西式信封機。',
                '四月：HP25500繪圖機安裝於台中總公司，乳膠墨水室內外通用，輸出品質媲美印刷品。',
                '七月：台中精密園區動土儀式。',
                '八月：三重工廠安裝全新小森四六全四色印刷機，為全台唯一廠內擁有三台全開尺寸印刷廠。',
                '八月：三重工廠新裝kODAK MAGNUS 800 CTP 及Screen DS PTR-8800 CTP電腦出版機各1台。',
                '十月：三重工廠新裝Horizon全自動高速騎馬釘裝訂線。',
                '十一月：新增第2台17噸貨車，全省物流車輛共達 51 台，讓配送路線更完善！',
                '十二月：台中工廠安裝全新小森四六全四色印刷機，為全世界唯一廠內擁有四台全開尺寸印刷廠。',
                '十二月：台中工廠安裝自動雙線圈桌月曆打孔裝訂機，提升生產效率。',
                '十二月：台中工廠安裝SX-460 大開本穿線機，提供更快速服務。',
            ],
        },
        {
            year: 98,
            content: [
                '元月：台中新工廠完工啟用，為健豪再豎立新里程碑，將為客戶提供更好服務！',
                '元月：月中，健豪 97 年度尾牙，假健豪台中工廠舉辦，宴請全體同仁及客戶，席開百桌、熱鬧非凡！',
                '二月：台中工廠安裝第11台印刷機--小森四六全印刷機，全開尺寸、印刷效率高快速！',
                '二月：Aster穿線機 裝機完成，提供更完善的服務。',
                '二月：中旬，中和廠舉辦Anicolor無色差、無鬼影發表會。',
                '三月：月初，台中廠舉辦新廠啟用暨新機發表會，廣邀全省客戶參加，並提供多種獎品抽獎。',
                '六月：中區影印紙開賣！',
                '七月：南區影印紙開賣！',
                '八月：全台最完美的KOLBUS膠裝(線膠裝)裝訂線，安裝於台中工廠，每小時裝訂速度達7000本。',
                '八月：HP Designjet L65500大型繪圖機安裝於台中總公司，輸出品質聘美印刷品。',
                '八月：新裝1台柯達CTP機器KODAK TRENDSETTER 800 III Platesetter 電腦出版機於台中工廠。',
                '九月：新裝1台柯達CTP機器KODAK TRENDSETTER 800 III Platesetter 電腦出版機於中和工廠。',
                '十月：月初， 新裝6台摺紙機及1台137公分裁刀機於台中工廠。',
                '十月：月初，安裝KOMORI小森 LITHRONE LS440 UV 四色菊全UV延長印刷機台中工廠。',
                '十月：台南營業處正式成立，對外營業並新增大圖機器設備。',
                '十二月：台中新裝柯達CTP出版機及新式大圖機器、中和則新增柯達CTP出版機提升生產效率。',
                '十二月：新增OPP上光機，尺寸可達145X102公分，全台最大。',
            ],
        },
        {
            year: 97,
            content: [
                '元月：健豪 96 年度尾牙，台中新天地餐廳舉辦，宴請客戶、同仁、同仁家屬，同仁抽獎獎項豐富、席開百桌、熱鬧非凡！',
                '三月：社子營業處正式開幕，座落於臺北市士林區，為健豪全省第五個營業據點。',
                '三月：中和廠，購入摺紙機等加工設備，提升出貨效率。',
                '四月：台中廠，購入中式信封機，自行於廠內加工更快出貨！',
                '七月：台中新購入「局部上光機」，局部上光等加工皆能於廠內自行加工！',
                '九月：台中購入上光機、護貝機等，並使用多麗膜，讓上光效果更好！',
                '九月：月底台中廠，汰換舊機，更換全新印刷機。',
                '十月：台中工廠擴廠並增蓋新廠房，即將提供更完善、更快速地出貨服務！',
                '十月：月底，1040X730mm全新平盤軋盒機完成啟用，速度快、尺寸齊全，廠內各種資料夾、紙盒軋型等，完全獨立作業。',
                '十一月：健豪員工旅遊，於宜蘭頭城農場展開兩天一夜活動，凝聚全體同仁向心力。',
                '十一月：月底， 17 噸貨車交車，全省物流車輛達 50 台，讓配送路線更縝密！',
                '十一月：健豪印刷榮獲第二屆金光印藝獎商業類銀牌大獎，為大中華區唯一台灣廠商獲獎!',
                '十二月：月中，蝴蝶頁精裝機 裝機成功，並推出 Photo Book 數位個人化產品！',
                '十二月：台中廠安裝菊全上下座雙色機，單一咬口，單色雙面一次完成！',
                '十二月：月底，中和廠安裝新一代Anicolor 5K印刷機，絕無色差與鬼影疑慮，品質與同業再拉開距離！',
            ],
        },
        {
            year: 96,
            content: [
                '三月：中和廠房遷移至新址，以全新風貌為大台北區客戶服務，服務範圍北至宜蘭，南至桃園。',
                '三月：新裝科達 Magnus 800 CTP 一台。',
                '四月：富士 V 8 CTP 兩台、裁刀機兩台、水性及油性大圖機十幾台裝機於中和新廠。',
                '六月：健豪第六、第七台印刷機：小森菊全四色、五色印刷機，裝機於中和廠房。',
                '七月：中和新廠開幕，正式入駐大台北地區，提供北部客戶更「在地服務」。',
                '九月：合版業界創舉：響應環保、愛護地球，全面性地將名片盒更換為「紙盒」。',
                '十月：健豪第八台印刷機：小森菊全五色加 UV 上光印刷機，裝機於台中工廠，名片商品全部改為 UV 印刷，杜絕背印問題。',
                '十月：lusher CTcP、 Basys CTcP 分別裝機於中和與台中工廠。',
                '十一月：健豪「獨有商品暨 UV 新機、 CTcP 新機發表會」，假台中工廠舉辦，上下午兩場發表會，創參加人數新高。',
            ],
        },
        {
            year: 95,
            content: [
                '二月：戶外油性噴畫機裝機，推出布條、帆布等噴圖商品。',
                '二月：推出特別色合版印刷，讓客戶以划算價格印製特別色。',
                '四月：引進超大戶外噴畫機，帆布最大輸出寬度可達300cm，省略客戶接圖困擾。',
                '四月：健豪與秋山共同舉辦的印刷發表會於健豪台中工廠舉辦，當天客戶廠商參加踴躍，締造健豪歷史。',
                '五月：健豪印訊第九期發行，發行數量已達2萬份。',
                '七月：裝設總價值超過四百萬元的光纖儲域設備，輸入輸出每秒可達4GB。',
                '九月：馬天尼騎馬釘機裝機完成，一小時可完成九千本騎馬釘書籍。',
                '十月：自動背刀機裝機完成，一次可背五、六刀，並可製作撕線。',
                '十月：推出割盒機服務，只要有刀模線，即可為客戶提供割盒或割形服務。',
                '十月：健豪第五台印刷機啟用：HP Indigo七色數位印刷機啟用，為台灣合版市場推出極短車商品。',
                '十一月：高雄健豪遷駐灣興街，同時裝設噴圖機、裁刀等設備，全省噴圖機已達20台。',
                '十二月：推出一盒即印的尊爵名片，數十種紙質可供選擇，適合頂級人士專用。',
                '十二月：擴大海報合版商品，各式印刷品不需報價，直接查閱健豪印刷價格表。',
            ],
        },
        {
            year: 94,
            content: [
                '三月：第三台富士CTP裝機，每小時出版突破100片。',
                '三月：增加兩條乙太網路，上下傳速度皆20MB；更為客戶準備FTP暫存空間達18TG。',
                '四月：第四台愛克發CTP裝機使用，總出版達140片。',
                '四月：中和健豪座落於中和橋和路。',
                '五月：軋型機、超音波、沖卡機，陸續裝機完成。',
                '六月：推出3D名片、透明資料夾、磨砂等UV印刷商品。',
                '六月：台中工廠場地簽約完成，並開始興建。',
                '七月：中和新廠開幕，正式入駐大台北地區，提供北部客戶更「在地服務」。',
                '九月：台中工廠完工，健豪正式入駐台中工業區。',
                '九月：廠內共有六台CTP(1台愛克發、5台富士CTP)，每小時出版量超過200片。',
                '九月：l第四台印刷機，秋山雙面菊全8色印刷機啟用。',
                '十一月：高雄健豪座落於高雄市家齊路。',
            ],
        },
        {
            year: 93,
            content: [
                '為達到印刷流程自動化的努力目標，完成自動搜尋檔案的軟體，大幅縮短印刷時間及人為疏失。購買裁刀機、車輛等器具，桃竹苗、中彰投地區並開始提供專車送貨服務。',
                '五月：第二部富士VX9600紫光雷射CTP出版裝機，讓健豪的合版印刷商品，完全轉為CTP出版，如同獨立版印刷。',
                '六月：第一部小型騎馬釘裝訂機啟用，健豪開始自行製作後加工。',
                '九月：第一台上光機裝機，提供客戶更優質的OPP上光。',
                '十二月：健豪的第三台印刷機為五開五色+UV上光印刷機，印刷與上光同步完成。',
            ],
        },
        {
            year: 92,
            content: [
                '年初購入富士VX-9600紫光雷射CTP機器，每小時可出菊全版37片，版材面積為全台最大。',
                '並導入電子工單作業流程，從接稿到製作，全部透過電子化的協助。',
                '二月推出「數位網點打樣」系統，透過模擬印刷網點的技術，讓印刷色彩及品質更能事先預估。',
                '四月健豪以"健蓁印刷"進駐大台北地區，開始深耕北部客戶。  十月第二台小森四色菊全印刷機啟用。連同廠外共有七部印刷機印製合版商品。',
                '十二月物流車隊已達九部，每天負責南北客戶專車送貨服務。',
            ],
        },
        {
            year: 91,
            content: [
                '五月成立客服部門，將印刷業引領為[印刷服務業]。',
                '九月第一台海德堡菊全四色印刷機裝機啟用、導入CIP4流程，提升印刷品質。',
                '十一月發行[印刷訊息]的健豪印訊創刊，發行份數5000份。',
            ],
        },
        {
            year: 90,
            content: [
                '購入新型愛克發紫光雷射CTP出版機，再度提高PS版輸出的交件效率。',
                '建構網路主機以E1、T1及兩條1.5MB專線，讓客戶透過網路送檔，客戶漸漸遍及台灣全島。  年初：富士F9000網片機裝機並啟用。',
            ],
        },
        {
            year: 89,
            content: [
                '結束CTP代工全面更新電腦設備，成立合版部門，開始跨足合版印刷。二月遷廠，進駐台中市忠明南路廠內總面積300坪。',
            ],
        },
        {
            year: 87,
            content: [
                '率先導入CTP（computer to plate）流程，成為台灣最成功的CTP流程的領導公司，協助了台灣各大合版公司出版事宜。',
            ],
        },
        {
            year: 86,
            content: [
                '健豪印刷正式成立，原名為：巨鼎印刷事業股份有限公司，初期營業項目為專業電子分色、大型海報輸出及電腦化網片輸出等三大項。',
            ],
        },
    ],
    equipments: [
        {
            type: '印前設備',
            desc: '多元的印前輸出設備',
            content: [
                {
                    image: '印前設備-01.png',
                    title: 'Durst Rho 512R Plus',
                    text: [
                        '噴印界的頂級機台，五米噴印一次完成，不需拼接，更快更美。',
                        '多LM、LC亮部調補強，印製人像更細緻更美觀。',
                        '',
                        '最大輸出寬度：510cm (全台唯一最大輸出尺寸)',
                        '噴印速度：4155才/小時 (全台唯一)。解析度：1200dpi (全台唯一)',
                        '6色UV油墨 (C、M、Y、K、LC、LM)',
                    ],
                },
                {
                    image: '印前設備-02.png',
                    title: 'Durst Rho 250HS Plus',
                    text: [
                        '噴印界的頂級機台，提供板材直噴、白墨、立體浮雕印刷服務。應用範圍更廣，效能更佳。LM、LC亮部調補強，印製人像更細緻更美觀。',
                        '最大輸出寬度：250mm',
                        '噴印速度：4305才/小時(全台唯一)',
                        '解析度：1000dpi(全台唯一)',
                        '油墨6色UV油墨+1白墨 (C、M、Y、K、LC、LM、W)',
                    ],
                },
                {
                    image: '印前設備-03.png',
                    title: '數位標籤機domino n610i',
                    text: [
                        'UV固化油墨，不需印刷前處理(不用電暈、不用塗佈) 適用被印材廣泛，加上紫、紅補強，色彩更飽和艷麗。',
                        '最大紙大：最大寬度340mm',
                        '最大印刷面積：最大寬度333mm',
                        '印刷速度：每分鐘7500cm',
                        '油墨UV固化油墨(C、M、Y、K、V、O、白墨)',
                    ],
                },
                {
                    image: '印前設備-04.png',
                    title: '德國頂級立體掃描設備CRUSE ：一台',
                    text: [
                        '全台最高端掃描服務，立體紋路真實呈現',
                        '免觸碰，不怕掃描品受傷，高30cm掃描不需拆框',
                        '最大原稿尺寸：100x150 cm',
                    ],
                },
                {
                    image: '印前設備-05.png',
                    title: '大圖輸出機 HP Latex 3000 Printer ：一台',
                    text: [
                        '(室內外通用) 使用HP原廠乳膠墨水',
                        '全國輸出寬度最大，戶外超大尺寸廣告、帆布，不必再接圖。',
                        '室內裝潢更無破綻。',
                        '解析度： 高達 1200 x 1200 dpi 。 最大輸出寬度：320 cm',
                        '速度快、解析高、不需接圖',
                    ],
                },
                {
                    image: '印前設備-06.png',
                    title: '大圖輸出機HP Scitex FB UV系列 繪圖機 ：二台',
                    text: [
                        '平面版材直接噴印，高附著力，耐光、耐水、耐候性，',
                        '色彩鮮豔飽和。',
                        '解析度： 高達 1200 x 600 dpi 。 最大輸出寬度：150 cm',
                    ],
                },
                {
                    image: '印前設備-07.png',
                    title: '大圖輸出機HP Designjet L65500大型繪圖機',
                    text: [
                        '(室內外通用) 使用HP原廠乳膠墨水',
                        '解析度： 高達 1200 x 1200 dpi 。 滿足最挑剔的眼睛!',
                        '六色墨水製作：色彩豐富、飽合度高、戶外展示高持久度 。',
                    ],
                },
                {
                    image: '印前設備-08.png',
                    title: '大圖輸出機 HP Designjet L26500繪圖機',
                    text: [
                        '(室內外通用) 使用HP原廠乳膠墨水',
                        '解析度： 600 x 1200 dpi 。 最大輸出寬度150CM',
                    ],
                },
                {
                    image: '印前設備-09.png',
                    title: '大圖輸出機 HP Designjet L25500繪圖機',
                    text: [
                        '(室內外通用) 使用HP原廠乳膠墨水',
                        '解析度： 600 x 1200 dpi 。 最大輸出寬度150CM',
                    ],
                },
                {
                    image: '印前設備-10.png',
                    title: '大圖輸出機 熱昇華',
                    text: [
                        '輸出解析度： 720 dpi 。 最大輸出寬度150CM',
                        '使用mutoh繪圖機',
                        '搭配熱昇華墨水進行噴繪在雙透布(或其他布類)',
                        '經過固色機高溫烘烤固色',
                        '讓顏色昇華使其顯色並產生防水效果',
                    ],
                },
                {
                    image: '印前設備-11.png',
                    title: '固色機',
                    text: [
                        '最大尺寸寬度為180cm',
                        '將經熱昇華墨水噴繪過的雙透布(或其他布類)',
                        '以200度的高溫照射、進行烘烤後固色',
                        '使其顏色顯色、鮮艷飽合並產生防水效果',
                    ],
                },
                {
                    image: '印前設備-12.png',
                    title: '水性：Hp5000cp 十台、Hp5100二台、Motoh 二十台',
                    text: [
                        '最大尺寸寬度為1500mm，最高解析為1440dpi，紙材PP相紙、噴墨專用',
                        '紙、PVC背膠、銅板紙、國畫纖維紙、幻彩相紙提供客戶各種要求。',
                    ],
                },
                {
                    image: '印前設備-13.png',
                    title: '油性：Mutoh VJ.. 油性噴畫機-二十台',
                    text: [
                        '紙材有帆布、相紙、PVC背膠、燈箱片，油畫布、布旗布...等',
                    ],
                },
                {
                    image: '印前設備-14.png',
                    title: '數位打樣機：Epson 9890、9860、9880、10600...十五台',
                    text: ['提供各式噴墨數位打樣。'],
                },
                {
                    image: '印前設備-15.png',
                    title: 'Screen CTF網片輸出機',
                    text: [
                        '最大尺寸：1120x810mm，可提供局部上光網片與手工曬版服務!',
                    ],
                },
                {
                    image: '印前設備-16.png',
                    title: 'KODAK TRENDSETTER 800 Platesetter 電腦出版機：八台',
                    text: ['最大輸出尺寸：1118X838mm', '輸出速度：40片/小時'],
                },
                {
                    image: '印前設備-17.png',
                    title: '最新柯達CTP電腦出版機：五台',
                    text: [
                        '每小時可出版為菊全版材40片，出版線數為200 線 !',
                        '最大輸出尺寸：1160X960mm',
                        '小輸出尺寸：500X400mm',
                        '輸出速度：40片/小時',
                    ],
                },
                {
                    image: '印前設備-18.png',
                    title: 'screen 8800CTP電腦出版機：一台',
                    text: ['每小時可出版為菊全版材50片，出版線數為200 線 !'],
                },
            ],
        },
        {
            type: '印中設備',
            desc: '全台最多印刷機群',
            content: [
                {
                    image: '印中設備-01.png',
                    title: '小森菊全GL840+C LED+UV印刷機',
                    text: [
                        '最大紙大：1030x720mm',
                        '最大印刷面積：1020x710mm',
                        '最小紙大：520x360mm',
                        '印刷紙張厚度:0.06~1.0mm',
                        '印刷速度：每小時可印刷172000張紙',
                    ],
                },
                {
                    image: '印中設備-02.png',
                    title: '海德堡 Speedmaster XL 75 Anicolor 印刷機',
                    text: [
                        '最大紙大：605x750mm',
                        '最小紙大：340x350mm',
                        '最大印刷面積：585x740mm',
                        '紙張厚度0.03~0.8mm',
                        '印刷速度：每小時可印刷15000張紙',
                    ],
                },
                {
                    image: '印中設備-03.png',
                    title: 'HP Indigo W7250 數位印刷機：三台',
                    text: [
                        '最大紙大：980x340mm',
                        '最大印刷面積：980x317mm',
                        '紙張厚度12gsm~450gsm',
                        '雙面印刷、各式極少量、個人化商品皆可製作。',
                    ],
                },
                {
                    image: '印中設備-04.png',
                    title: 'HP Indigo 10000 數位印刷機：三台',
                    text: [
                        '最大紙大：750x530mm',
                        '最大印刷面積：740x510mm',
                        '紙張厚度70gm~450gm',
                        '各式極少量、個人化商品皆可製作，多次印刷絕無色差疑慮。',
                    ],
                },
                {
                    image: '印中設備-05.png',
                    title: 'HP Indigo WS6600 數位印刷機：三台',
                    text: [
                        '最大紙大：980x340mm',
                        '最大印刷面積：980x317mm',
                        '紙張厚度12gsm~450gsm',
                        '各式極少量、個人化商品皆可製作，多次印刷絕無色差疑慮。',
                    ],
                },
                {
                    image: '印中設備-06.png',
                    title: 'HP Indigo 5600數位印刷機：二台',
                    text: [
                        '最大紙大：480x330mm',
                        '最大印刷面積：450x317mm',
                        '紙張厚度70gm~400gm',
                        '各式極少量、個人化商品皆可製作，多次印刷絕無色差疑慮。',
                        '(如需無色差，則需全部於數位印刷機上印刷)',
                    ],
                },
                {
                    image: '印中設備-07.png',
                    title: 'HP Indigo 4500數位印刷機：三台',
                    text: [
                        '最大紙大：450x315mm',
                        '最大印刷面積：450x300mm',
                        '紙張厚度12gsm~350gsm',
                        '各式極少量、個人化商品皆可製作，多次印刷絕無色差疑慮。',
                        '(如需無色差，則需全部於數位印刷機上印刷)',
                    ],
                },
                {
                    image: '印中設備-08.png',
                    title: 'KONICA MINOLTA C70hc 數位印刷機：一台',
                    text: [
                        '最大紙大：482x330mm',
                        '最大印刷面積：472x320mm',
                        '紙張厚度70gsm-300gsm',
                        '各式極少量、個人化商品皆可製作。',
                    ],
                },
                {
                    image: '印中設備-09.png',
                    title: 'KONICA MINOLTA C1070 數位印刷機',
                    text: [
                        '最大紙大：487x330mm',
                        '最大印刷面積：480x323mm',
                        '紙張厚度62gsm-300gsm',
                    ],
                },
                {
                    image: '印中設備-10.png',
                    title: '海德堡 C751 數位印刷機',
                    text: [
                        '最大紙大：485x330mm',
                        '最大印刷面積：475x320mm',
                        '紙張厚度80gsm-300gsm',
                    ],
                },
                {
                    image: '印中設備-11.png',
                    title: '海德堡印刷機 XL-106 LEUV　',
                    text: [
                        '機上自動濃度檢測 印中自動校正',
                        '最大紙大：1060x750mm',
                        '最大印刷面積為1050x740mm',
                        '紙張厚度：0.03mm~1mm',
                        '印刷速度：每小時可印刷18000張紙',
                    ],
                },
                {
                    image: '印中設備-12.png',
                    title: '海德堡 Speedmaster XL 75 Anicolor',
                    text: [
                        '最大紙大：605x750mm',
                        '最小紙大：210x350mm',
                        '最大印刷面積：585x740mm',
                        '紙張厚度0.03~0.8mm',
                        '印刷速度：每小時可印刷15000張紙',
                    ],
                },
                {
                    image: '印中設備-13.png',
                    title: 'KOMORI小森LITHRONE G40',
                    text: [
                        '菊全四色HUV印刷機-一台',
                        '最大紙大：1030x720mm',
                        '最小紙大：545X363mm',
                        '最大印刷面積為1020x710mm',
                        '紙張厚度：0.04mm~0.8mm',
                    ],
                },
                {
                    image: '印中設備-14.png',
                    title: '海德堡 SM52-5LX UV',
                    text: [
                        '五開五色/六色UV印刷機-二台',
                        '最大紙大：520x370mm',
                        '最大印刷面積：520x360mm',
                        '最大上光面積：510x355mm',
                        '印刷紙張厚度：0.5mm(0.5mm以上無法印刷)',
                        '印刷速度：每小時可印刷15000張紙',
                        '適印塑料、不易乾燥紙張，同步印刷五色及上光的功能!',
                    ],
                },
                {
                    image: '印中設備-15.png',
                    title: 'KOMORI小森LITHRONE S540+C UV',
                    text: [
                        '菊全五色+上光UV印刷機-一台',
                        '最大紙大：1030x720mm',
                        '最小紙大：545x363mm',
                        '最大印刷面積：1020x710mm        ',
                        '印刷紙張厚度：從0.15mm到1mm',
                        '更適合印製各式塑料、不易乾襙紙張',
                    ],
                },
                {
                    image: '印中設備-16.png',
                    title: 'KOMORI小森LITHRONE S440 UV',
                    text: [
                        '菊全四色UV延長印刷機-一台',
                        '最大紙大：1030x720mm',
                        '最小紙大：545x363mm',
                        '最大印刷面積：1020x710mm',
                        '印刷紙張厚度：從0.1mm到0.8mm',
                        '更適合印製各式塑料、不易乾襙紙張',
                    ],
                },
                {
                    image: '印中設備-17.png',
                    title: '海德堡印刷機XL-105 ',
                    text: [
                        '機上自動濃度檢測 印中自動校正',
                        '最大紙大：1050x750mm',
                        '最大印刷面積為1050x740mm',
                        '紙張厚度：0.03mm~1mm',
                        '印刷速度：每小時可印刷18000張紙',
                    ],
                },
                {
                    image: '印中設備-18.png',
                    title: 'KOMORI小森LITHRONE S-444',
                    text: [
                        '全台最新四六全四色印刷機-四台',
                        '最大紙大：1130x820mm 最小紙大：645X460mm',
                        '最大印刷面積：1120x810mm',
                        '紙張厚度：0.04mm~0.8mm',
                        '印刷速度：每小時可印刷15000張紙',
                    ],
                },
                {
                    image: '印中設備-19.png',
                    title: 'Akiyama 秋山 Jprint 1P140',
                    text: [
                        '菊全1+1雙面印刷機-一台',
                        '最大紙大：1030x720mm',
                        '最大印刷面積：1020x715mm',
                        '印刷紙張厚度：從0.04mm到0.2mm',
                        '印刷速度：每小時可印刷13000張紙',
                        '一次同時印刷雙面，更加提升印刷效率!',
                    ],
                },
                {
                    image: '印中設備-20.png',
                    title: '海德堡 SM52-4Anicolor',
                    text: [
                        '五開四色印刷機 Anicolor印刷機-一台',
                        '最大紙大：520x370mm',
                        '最大印刷面積：520x360mm',
                        '印刷紙張厚度：從0.03mm到0.4mm(0.5mm以上無法印刷)',
                        '印刷速度：每小時可印刷15000張紙',
                        '一致的色彩呈現，克服色差問題。',
                    ],
                },
                {
                    image: '印中設備-21.png',
                    title: 'KOMORI小森LITHRONE S440',
                    text: [
                        '菊全四色印刷機-三台',
                        '最大紙大：1030x720mm',
                        '最小紙大：545x363mm',
                        '最大印刷面積：1020x710mm',
                        '印刷速度：每小時可印刷16500張紙',
                        '印刷紙張厚度：從0.04mm到0.8mm',
                        '自動換版系統：提高印刷效率',
                        '自動控墨系統：顏色穩定、準確',
                    ],
                },
                {
                    image: '印中設備-22.png',
                    title: 'KOMORI小森LITHRONE LS-240 SP',
                    text: [
                        '菊全雙面雙色印刷機-一台',
                        '最大紙大：1030x720mm',
                        '最小紙大：545x363mm',
                        '最大印刷面積：1020x710mm',
                        '印刷紙張厚度：從0.04mm到0.3mm',
                        '印刷速度：每小時可印刷15000張紙',
                    ],
                },
                {
                    image: '印中設備-23.png',
                    title: 'KOMORI小森LITHRONE S540',
                    text: [
                        '菊全五色印刷機-一台',
                        '最大紙大：1030x720mm',
                        '最小紙大：545x363mm',
                        '最大印刷面積：1020x710mm',
                        '印刷紙張厚度：0.04mm~0.8mm',
                        '印刷速度：每小時可印刷16500張紙',
                        '自動控墨系統：顏色穩定、準確',
                        '自動換版系統：提高印刷效率',
                    ],
                },
            ],
        },
        {
            type: '印後設備',
            desc: '最新的數位精裝線及完善的後加工設備：健豪一貫作業，為您直接處理各式後加工品',
            content: [
                {
                    image: '印後設備-01.png',
                    title: '局部雷射上光機：一台',
                    text: [],
                },
                {
                    image: '印後設備-02.png',
                    title: 'MARTINI 馬天尼鑽石型精裝線',
                    text: [
                        '全世界第一套針對短版及快速變換書本厚度裝訂方式而設計的數位化精裝設備',
                    ],
                },
                {
                    image: '印後設備-03.png',
                    title: 'MARTINI 馬天尼超越型數位膠裝機',
                    text: [
                        '全球第一台 馬天尼ALEGRO數位膠裝裝訂線',
                        '相同尺寸但不同厚度的書籍 只要厚度相差4MM內皆可不用再重新校車而直接生產',
                    ],
                },
                {
                    image: '印後設備-04.png',
                    title: 'MARTINI 馬天尼飛舞型B9膠裝機',
                    text: [
                        '全自動數位化膠裝設備，由機器自動完成調整，大幅縮短裝訂前準備時間，18個自動配頁站及1個手動配頁站。',
                    ],
                },
                {
                    image: '印後設備-05.png',
                    title: 'MARTINI 馬天尼霹靂馬型騎馬釘機',
                    text: [
                        '內頁採套台的方式， 釘子裝訂在書籍最中間， 書籍能完全攤平',
                    ],
                },
                {
                    image: '印後設備-06.png',
                    title: 'OPP覆膜機四台、開窗覆膜機一台',
                    text: ['Sakurai局部上光機二台、SPS局部上光機一台'],
                },
                {
                    image: '印後設備-07.png',
                    title: 'OPP高速覆膜機-一台',
                    text: [],
                },
                {
                    image: '印後設備-08.png',
                    title: '昌利BB-018彎刀機',
                    text: [
                        '按照刀模線的檔案，將刀片彎曲、調整角度、長度可製作出不規則圖形的刀片樣式',
                    ],
                },
                {
                    image: '印後設備-09.png',
                    title: '昌利BC-012切刀機',
                    text: ['用於切割刀片，搭配彎刀機使用裁切K刀 (摺線) 使用'],
                },
                {
                    image: '印後設備-10.png',
                    title: 'Komatsu-TLV408 雷射機',
                    text: ['從薄板到厚板的平坦表面的板材可以切割'],
                },
                {
                    image: '印後設備-11.png',
                    title: 'HORAUF',
                    text: [
                        'BDM Universal-Digatll 自動硬殼生產機',
                        '能以每分鐘60個的速度，全自動化生產精裝書殼，檯曆和遊戲板。',
                    ],
                },
                {
                    image: '印後設備-12.png',
                    title: 'MARTINI 馬天尼突破型穿線機',
                    text: [],
                },
                {
                    image: '印後設備-13.png',
                    title: '電腦裁刀機-十八台',
                    text: [],
                },
                {
                    image: '印後設備-14.png',
                    title: '平盤軋型機軋工優惠，歡迎洽詢！',
                    text: ['最大軋型尺寸：1040X730mm'],
                },
                {
                    image: '印後設備-15.png',
                    title: '平盤軋型機軋工優惠，歡迎洽詢！',
                    text: ['最大軋型尺寸：1040X730mm'],
                },
                {
                    image: '印後設備-16.png',
                    title: 'KOLBUS KM600 Line 膠裝（線膠裝）裝訂線',
                    text: [],
                },
                {
                    image: '印後設備-17.png',
                    title: 'MARTINI 馬天尼騎馬裝訂機',
                    text: [],
                },
                {
                    image: '印後設備-18.png',
                    title: '艾思可 割盒機',
                    text: [
                        '全自動割盒(形)機，卡紙、貼紙、豪卡版等，割盒一次完成，只要有刀模線，一個盒子30秒即可完成。',
                    ],
                },
                {
                    image: '印後設備-19.png',
                    title: 'JK-650PC 糊盒機',
                    text: [
                        '適用紙質： 紙板',
                        '機械速度： 最快 300m/min',
                        '糊劑： 溶質性',
                    ],
                },
                {
                    image: '印後設備-20.png',
                    title: '圓刀覆膜軋型機',
                    text: [],
                },
                {
                    image: '印後設備-21.png',
                    title: '切片機',
                    text: [],
                },
                {
                    image: '印後設備-22.png',
                    title: '塗佈機(平張)CM-2000GE',
                    text: [],
                },
                {
                    image: '印後設備-23.png',
                    title: '塗佈機(捲裝)',
                    text: [],
                },
                {
                    image: '印後設備-24.png',
                    title: '覆膜機-8000B',
                    text: [],
                },
                {
                    image: '印後設備-25.png',
                    title: '覆膜機-SADF-540B',
                    text: [],
                },
                {
                    image: '印後設備-26.png',
                    title: '摺紙機',
                    text: [],
                },
                {
                    image: '印後設備-27.png',
                    title: 'PUR膠裝機',
                    text: [],
                },
                {
                    image: '印後設備-28.png',
                    title: '全自動書殼封面機',
                    text: [],
                },
                {
                    image: '印後設備-29.png',
                    title: '超音波機',
                    text: [],
                },
                {
                    image: '印後設備-30.png',
                    title: '自動背刀機',
                    text: [
                        '最大尺寸80x80cm ，一次最多可背12刀',
                        '最小尺寸：20x20cm。',
                    ],
                },
                {
                    image: '印後設備-31.png',
                    title: '沖卡機',
                    text: [],
                },
                {
                    image: '印後設備-32.png',
                    title: '自動摺封口機',
                    text: [],
                },
                {
                    image: '印後設備-33.png',
                    title: 'Horizon全自動高速騎馬釘裝訂線',
                    text: [],
                },
                {
                    image: '印後設備-34.png',
                    title: 'Shoei摺紙機-十二台/Horizon 摺紙機二台',
                    text: [],
                },
                {
                    image: '印後設備-35.png',
                    title: 'Horizon-事務型膠裝機',
                    text: [],
                },
                {
                    image: '印後設備-36.png',
                    title: '蝴蝶頁精裝機',
                    text: [],
                },
                {
                    image: '印後設備-37.png',
                    title: 'Aster180-穿線機',
                    text: [],
                },
                {
                    image: '印後設備-38.png',
                    title: 'Horizon事務型騎馬釘裝訂機',
                    text: [],
                },
                {
                    image: '印後設備-39.png',
                    title: '小型壓線機',
                    text: [],
                },
                {
                    image: '印後設備-40.png',
                    title: 'SX-460大開本穿線機',
                    text: [],
                },
                {
                    image: '印後設備-41.png',
                    title: '自動雙線圈月曆打孔裝訂機',
                    text: [],
                },
                {
                    image: '印後設備-42.png',
                    title: '9K信封機',
                    text: [],
                },
                {
                    image: '印後設備-43.png',
                    title: '中式信封機',
                    text: [],
                },
                {
                    image: '印後設備-44.png',
                    title: '西式(歐式)信封機',
                    text: [],
                },
                {
                    image: '印後設備-45.png',
                    title: '中四K信封機',
                    text: [],
                },
                {
                    image: '印後設備-46.png',
                    title: '平燙流水號',
                    text: [],
                },
                {
                    image: '印後設備-47.png',
                    title: '軋型燙金機',
                    text: [],
                },
                {
                    image: '印後設備-48.png',
                    title: '八開軋型燙金機',
                    text: [],
                },
                {
                    image: '印後設備-49.png',
                    title: '導圓角機-數台',
                    text: [],
                },
                {
                    image: '印後設備-50.png',
                    title: '打孔機-數台',
                    text: [],
                },
                {
                    image: '印後設備-51.png',
                    title: '打凸燙金流水號',
                    text: [],
                },
                {
                    image: '印後設備-52.png',
                    title: 'IP沖卡機',
                    text: [],
                },
            ],
        },
    ],
} as const;
